import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/fruit"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2C9.89544 2 9.00001 2.89543 9.00001 4V5.36074C9.85749 4.95042 10.8298 4.82709 11.7813 5.07723C14.0443 5.67213 15.3326 8.15422 14.6589 10.6211C13.9851 13.088 11.7311 15.5964 9.09748 14.904C8.65775 14.7884 8.27266 14.6007 7.93936 14.3568C7.60606 14.6007 7.22098 14.7884 6.78127 14.904C4.14767 15.5963 1.89362 13.088 1.21988 10.6211C0.546141 8.15419 1.83448 5.67211 4.09746 5.0772C5.0941 4.8152 6.11357 4.96293 7.00001 5.42105V4C7.00001 3.81799 7.01217 3.63882 7.03571 3.46326C6.2922 3.89496 5.21783 3.87256 4.27145 3.32616C3.17863 2.69522 2.60557 1.56716 2.81231 0.607587C3.53988 -0.051647 4.80365 -0.119558 5.89671 0.511518C6.67328 0.959875 7.18739 1.65927 7.34572 2.37084C7.96954 0.973711 9.37106 0 11 0V2Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Fruit16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Fruit16 = createIcon(IconComponent);